import React, {useEffect, useState, useRef} from "react";
import {Form, Col, Input, Button, Collapse, Card, notification} from 'antd';
import jsonfile from './nation.json'
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import moment from "moment";
import PerformanceComparison from "./performancecomparison";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useReactToPrint } from 'react-to-print';

const Panel = Collapse.Panel;

const PerformanceComparisonReport = () => {
    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef });
    const [state, setState] = useState({
        reqURL: Config.apiserver + jsonfile.urls.performancecomparison,
        filtervalue: '',
        subtitle: '',
        period: "For the month of " + CisUI().getMonthTitle(moment().format("YYYY-12-31")),
        currentYear: "as of " + CisUI().getMonthTitle(moment().format("YYYY-12-31")),
        lastYear: '',
        reporttype: "periodical"
    });

    const [reportyear,setReportYear] = useState({
        currentYear: "Current YR "+moment().format("YYYY"),
        lastYear: "Prior YR "+moment().subtract(1,"year").format("YYYY"),
        variance: "Variance",
        change: "% of Change"
    });

    const [reqURL,setReqURL] = useState(jsonfile.urls.performancecomparison);
    const [dateset,setDate] = useState("");
    const [header, setHeader] = useState("");
    const [period, setPeriod] = useState("For the month of " + CisUI().getMonthTitle(moment().format("YYYY-MM-DD")));

    const [hide, setHide] = useState([]);
    const [company, setCompany] = useState({});

    const ref = React.createRef();
    const formRef = React.createRef();

    const [data, setData] = useState([]);
    const [resp, setResp] = useState({
        status: 0,
        msg: "General Ledger",
        company: {},
        incomes: [],
        expenses: [],
        total_income: 0,
        totalIncome : {},
        totalExepenses : {},
        total_expense: 0,
        profit: 0,
        beginning_balance: 0,
        ending_balance: 0
    });

    useEffect(() => {
        if(CisUI().getUserInfo('com_id') > 0) {
            getLedgerData();
        }
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check if Ctrl (or Cmd on Mac) + P is pressed
            if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
                event.preventDefault();
                reactToPrintFn();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [reactToPrintFn]);



    const getDetailsLink = (source,id) => {
        // if(source === 'Bill Payment') {
        //     return "../../"+jsonfile.detaillink.bill+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Journal') {
        //     return "../../"+jsonfile.detaillink.journal+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Vendor Bill') {
        //     return "../../"+jsonfile.detaillink.bill+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Ledger') {
        //     return "../../"+jsonfile.detaillink.ledgerdetails+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Invoice') {
        //     return "../../"+jsonfile.detaillink.invoice+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Credit Note') {
        //     return "../../"+jsonfile.detaillink.creditnote+"/"+id+"?date="+dateset;
        // }
        // else {
        //     return "../../"+jsonfile.detaillink.journal+"/"+id+"?date="+dateset;
        // }

        return "../../accounts/ledger?account_id="+id+"&date="+dateset;
    }

    const getLedgerData = (url = "") => {
        document.getElementById("loader").style.display = "block";
        let urls = reqURL;
        if (url !== "") {
            urls = url;
        }
        axios.get(urls)
            .then(res => {
                // console.log(res)
                if (res.data.status === 1) {
                    setData(res.data.data);
                    setCompany(res.data.company);
                    setHeader(res.data.company.legal_name);
                    setResp(res.data);
                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }
                document.getElementById("loader").style.display = "none";
            })
            .catch(errors => {
                // console.log(errors.response.data.errors);
                // document.getElementById("loader").style.display = "none";
            });
    }

    const history = useHistory();

    const headers = {
        // _id: {
        //     text: '#',
        //     invisible: false,
        //     filterable: false,
        //     transform: (value) => `${++value}`,
        // },
        id: {
            invisible: true
        },
        date: {
            text: <IntlMessages id="Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().DateFormat(value)
            )
        },
        debit: {
            text: <IntlMessages id="Debit"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        credit: {
            text: <IntlMessages id="Credit"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        }
    };

    const orderedHeaders = jsonfile.listView.title;

    const getFields = () => {
        const count = expand ? 10 : 6;
        const children = [];
        const inputs = jsonfile.input;

        inputs.map((list, index) => {
            if (list.isFilterable == 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} key={index} style={{display: index < count ? 'block' : 'none'}}>
                        <div className="gx-form-row0">
                            <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    },
                                ]}
                            >
                                <Input placeholder={list.name}/>
                            </Form.Item>
                        </div>
                    </Col>,
                );
            }
        });
        return children;
    };

    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();

    const onFinish = values => {
        let wkd = "";
        let wk = "";
        let dt = [];
        let Month = ""
        let reprotType = "periodical";
        const qs = Object.keys(values).map(key => {
            if(key === 'month') {
                Month = values[key];
                const MNT = moment(values[key]).format("YYYY-MM-DD");
                return `${key}=${MNT}`
            }
        }).join('&');

        let ReprotPeriod = "For the month of " + CisUI().getMonthTitle(Month);
        let CurrentYear = "as of " + CisUI().getMonthTitle(Month);
        let LastYear = "";
         const qsup = qs.replaceAll("undefined", "");
        //reqURL = reqURL+"/?"+qsup;
        history.push("?" + qsup);
        const newURL = Config.apiserver + jsonfile.urls.performancecomparison + "?" + qsup;
        setState({
            reqURL: newURL,
            filtervalue: '',
            subtitle: '',
            period: ReprotPeriod,
            currentYear: CurrentYear,
            lastYear: LastYear,
            reporttype: reprotType
        });
        setPeriod(ReprotPeriod);
        getLedgerData(newURL);
    };


    let searchView = "";
    if (jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']}>
                <Panel header="Advance Search" key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        ref={formRef}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch([], "", 0,"month")}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    // const print = () => {
    //     window.print();
    // }


    const getAPIDataXLS = (APIUrl,qrystring) => {
        let URL  = APIUrl+"/xls?"+qrystring+"&token="+localStorage.getItem("token") || 0;
        if(APIUrl.includes("?")) {
            const sp = APIUrl.split("?");
            URL  = sp[0]+"/xls?"+sp[1]+"&token="+localStorage.getItem("token") || 0;
        }
        console.log("URL :"+URL);
        window.open(URL,"_blank");
    };

    const listAction = () =>
        (
            <div className="no-print">

                <button onClick={reactToPrintFn} className="btn btn-export-print btn-circle-md" title="Print"><i
                    className="fas fa-print"/></button>
            </div>
        );

    const getExtra = (
        <>
            {/*{CisUI().listActionReportXLS("","",state.reqURL,"data","income_statement",jsonfile,"Income Statement")}*/}

            {listAction()}
        </>
    );

    const setCollapse = (id) => {
        console.log("Slcct: ", id);
        if (hide.indexOf(id) > -1) {
            var index = hide.indexOf(id); // Let's say it's Bob.
            hide.splice(index, 1);
            document.getElementById("icon_" + id).setAttribute("class", "fas fa-chevron-right")
            var row = document.getElementsByClassName("disp_" + id);
            var thisYear = document.getElementsByClassName("this_" + id);

            var i;
            for (i = 0; i < row.length; i++) {
                //row[i].style.display = 'inherit';
                //row[i].removeAttribute('style');
                row[i].style.display = 'none';
            }

            for (i = 0; i < thisYear.length; i++) {
                thisYear[i].removeAttribute('style');
            }
        } else {
            const hd = hide;
            hd.push(id);
            setHide(hd);
            document.getElementById("icon_" + id).setAttribute("class", "fas fa-chevron-down");
            var row = document.getElementsByClassName("disp_" + id);
            var thisYear = document.getElementsByClassName("this_" + id);
            var i;
            for (i = 0; i < row.length; i++) {
                //row[i].style.display = 'none';
                row[i].removeAttribute('style');
            }

            for (i = 0; i < thisYear.length; i++) {
                //row[i].style.display = 'none';
                thisYear[i].style.display = "none";
            }
        }
        console.log("hides : ", hide);
    }

    const ComponentToPrint = React.forwardRef(function(props, ref) {
        return (
            <div ref={ref}>
                <div className="table-responsive">
                    <div style={{textAlign: 'center'}}>
                        <h2>{header}</h2>
                        <h4>Monthly Performance Report</h4>
                        <h4>{period}</h4>
                    </div>

                    <table className="statement table mx-auto w-auto">
                        <thead>
                        <tr>
                            <th style={{width: '400px'}}>Description</th>
                            <th style={{textAlign: 'right', width: '130px'}}>Current Month Actual</th>
                            <th style={{textAlign: 'right', width: '130px'}}>Last Month Actual</th>
                            <th style={{textAlign: 'right', width: '130px'}}>Variance</th>
                            <th style={{textAlign: 'right', width: '130px'}}>Budget (Current Month)</th>
                            <th style={{textAlign: 'right', width: '130px'}}>ACTUAL TO BUDGET (CMA  VS CMB)</th>
                            <th style={{textAlign: 'right', width: '130px'}}>YTD Actual (Current Year)</th>
                            <th style={{textAlign: 'right', width: '130px'}}>YTD Actual (Last year)</th>
                            <th style={{textAlign: 'right', width: '130px'}}>YTD Budget</th>
                            <th style={{textAlign: 'right', width: '130px'}}>YTD Variance</th>
                            <th style={{textAlign: 'right', width: '130px'}}>YTD ACTUAL VS YTD BUDGET</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td style={{fontWeight: 'bold'}}>Income :</td>
                            <td style={{textAlign: 'right', fontWeight: 'bold'}}>&nbsp;</td>
                        </tr>
                        {
                            resp?.incomes?.map((itmes, index) => {
                                var row = [];
                                row.push(<tr>
                                    <td className="clmintent no-border"
                                        style={{fontWeight: 'normal', paddingLeft: '40px'}}>
                                        <div className="subItemText">
                                            {itmes["child"]?.length > 0 ?
                                                <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                       onClick={() => setCollapse(itmes.id)}
                                                                                       className="fas fa-chevron-right"/> </span>
                                                : <></>}
                                            {itmes.account}</div>
                                    </td>
                                    <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.currentMonthActual)}</Link></span></td>
                                    <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.lastMonthActual)}</Link></span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.variance)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.budgetCurrentMonth)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.actualCurrentMonth)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdActualCurrentYear)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdActualLastYear)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdBudget)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdVariance)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdActualBudget)}</span></td>
                                </tr>)

                                itmes["child"]?.map((itm,ix)=>{
                                    if(itm.type === 'total') {
                                        row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}} >
                                            <td className="clmintent no-border"
                                                style={{fontWeight: 'bold', paddingLeft: '40px'}}>
                                                <div className="subItemText2">{itm.account}</div>
                                            </td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.currentMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.lastMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.variance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.budgetCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.actualCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualCurrentYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualLastYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdBudget)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdVariance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualBudget)}</span></td>
                                        </tr>)
                                    }
                                    else {
                                        row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}} >
                                            <td className="clmintent no-border"
                                                style={{fontWeight: 'normal', paddingLeft: '40px'}}>
                                                <div className="subItemText2">{itm.account}</div>
                                            </td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.currentMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.lastMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.variance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.budgetCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.actualCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualCurrentYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualLastYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdBudget)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdVariance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualBudget)}</span></td>
                                        </tr>)
                                    }
                                })

                                return row;
                            })
                        }
                        <tr className="showTotalBorder">
                            <td style={{fontWeight: 'bold'}}>Total Income :</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.currentMonthActual)}</td>
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{CisUI().getCurrencyFormated1(resp.totalIncome?.lastMonthActual)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.variance)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.budgetCurrentMonth)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.actualCurrentMonth)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.ytdActualCurrentYear)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.ytdActualLastYear)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.ytdBudget)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.ytdVariance)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalIncome?.ytdActualBudget)}</td>
                        </tr>

                        <tr>
                            <td style={{fontWeight: 'bold'}}>Expenses :</td>
                            <td style={{textAlign: 'right', fontWeight: 'bold'}}>&nbsp;</td>
                        </tr>
                        {
                            resp.expenses.map((itmes, index) => {
                                var row = [];
                                row.push(<tr>
                                    <td className="clmintent no-border"
                                        style={{fontWeight: 'normal', paddingLeft: '40px'}}>
                                        <div className="subItemText">
                                            {itmes["child"].length > 0 ?
                                                <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                       onClick={() => setCollapse(itmes.id)}
                                                                                       className="fas fa-chevron-right"/> </span>
                                                : <></>}
                                            {itmes.account}</div>
                                    </td>
                                    <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.currentMonthActual)}</Link></span></td>
                                    <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.lastMonthActual)}</Link></span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.variance)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.budgetCurrentMonth)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.actualCurrentMonth)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdActualCurrentYear)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdActualLastYear)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdBudget)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdVariance)}</span></td>
                                    <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.ytdActualBudget)}</span></td>
                                </tr>)

                                itmes["child"].map((itm,ix)=>{
                                    if(itm.type === 'total') {
                                        row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}} >
                                            <td className="clmintent no-border"
                                                style={{fontWeight: 'bold', paddingLeft: '40px'}}>
                                                <div className="subItemText2">{itm.account}</div>
                                            </td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.currentMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.lastMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.variance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.budgetCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.actualCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualCurrentYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualLastYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdBudget)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdVariance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualBudget)}</span></td>
                                        </tr>)
                                    }
                                    else {
                                        row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}} >
                                            <td className="clmintent no-border"
                                                style={{fontWeight: 'normal', paddingLeft: '40px'}}>
                                                <div className="subItemText2">{itm.account}</div>
                                            </td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.currentMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{ textAlign: 'right', fontWeight: 'normal' }}><span className={"this_" + itm.id} ><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.lastMonthActual)}</Link></span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.variance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.budgetCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.actualCurrentMonth)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualCurrentYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualLastYear)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdBudget)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdVariance)}</span></td>
                                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'normal'}}><span className={"this_" + itm.id} >{CisUI().getCurrencyFormated1(itm.ytdActualBudget)}</span></td>

                                        </tr>)
                                    }
                                })

                                return row;
                            })
                        }
                        <tr className="showTotalBorder">
                            <td style={{fontWeight: 'bold'}}>Total Expenses : </td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.currentMonthActual)}</td>
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{CisUI().getCurrencyFormated1(resp.totalExpense?.lastMonthActual)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.variance)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.budgetCurrentMonth)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.actualCurrentMonth)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.ytdActualCurrentYear)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.ytdActualLastYear)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.ytdBudget)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.ytdVariance)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.totalExpense?.ytdActualBudget)}</td>

                        </tr>
                        <tr className="showTotalBorder">
                            <td style={{fontWeight: 'bold'}}>Profit/Loss</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.currentMonthActual)}</td>
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{CisUI().getCurrencyFormated1(resp.profit?.lastMonthActual)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.variance)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.budgetCurrentMonth)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.actualCurrentMonth)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.ytdActualCurrentYear)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.ytdActualLastYear)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.ytdBudget)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.ytdVariance)}</td>
                            <td className="no-border" style={{textAlign: 'right', fontWeight: 'bold'}}>{CisUI().getCurrencyFormated1(resp.profit?.ytdActualBudget)}</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );
    });


    return (
        <>
            {searchView}
            <Card extra={getExtra}>
                {CisUI().showLoading}
                {resp.status === 1 ?
                    <div>
                        <ComponentToPrint ref={contentRef} />
                    </div>
                    : ""}

            </Card>
        </>
    );
};

export default PerformanceComparisonReport;